/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
		
    		// $(".wrap").fitVids();
    		
    		var $hamburger = $(".hamburger");
    		$hamburger.on("click", function(e) {
    			$hamburger.toggleClass("is-active");
    			// Do something else, like open/close 
          $("#main-navigation").toggleClass('show');
    		});
    		
        // open schedule in main nav in new window
        $(".menu-schedule > a, .menu-shop > a").attr("target","_blank");

        // sticky items
        // var stickyTop = $(".tout-banner-top").offset().top;
        var banner = $(".tout-banner-top.sticky").position();
        var bannerTop = banner.top;

        //whenever the user scrolls, measure how far we have scrolled
        $(window).scroll(function() {

          var windowTop = $(window).scrollTop();
          
          // console.log("banner:" + bannerTop);
          // console.log("window:" + windowTop);

          //check to see if we have scrolled past the original location of the sticky element
          if (windowTop > bannerTop) {

            //if so, change the sticky element to fixed positioning
            $(".sticky").addClass("stuck");
            
          } else {   
          
            $(".sticky").removeClass("stuck");
            
          }

        });

        // social shares
        $('.social-share-buttons').find('a.soc').on('click', function(e) {

          var 
            width = this.data-width || 800,
            height = this.data-height || 500;

          // popup position
          var
            px = Math.floor(((screen.availWidth || 1024) - width) / 2),
            py = Math.floor(((screen.availHeight || 700) - height) / 2);

          // open popup
          var popup = window.open(this.href, "Social",
            "width="+width+",height="+height+",left="+px+",top="+py+",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

          if (popup) {
            popup.focus();
            if (e.preventDefault){ e.preventDefault(); }
            e.returnValue = false;
          }

          return !!popup;
        });

        /*$(function() {
          var COOKIE_NAME = 'asf-marketing-nag';
          $go = Cookies.get(COOKIE_NAME);
          if ($go == null) {
            Cookies.set(COOKIE_NAME, 'crumb', { path: '/' });
            // Cookies.set(COOKIE_NAME, 'crumb', { expires: 1, path: '/' }); // without expires it's a sesion cookie
            $("#marketing_nag").delay( 2000 ).fadeIn( "fast", function() {
              // Animation complete
              console.log("nag shown.");
              console.log("cookie '" + COOKIE_NAME + "' created.");
            });
          } else {
            // don't show the nag
            $("#marketing_nag").css("display","none");
            //$(".footer-nag, .galleries-nag").css("display","none");
          }

          // marketing nag closer
          $("#marketing_nag .closer").click(function() {
            $("#marketing_nag").fadeOut( "fast", function() {
              // Animation complete
              // console.log("nag faded out.");
            });
            // for testing
            Cookies.remove(COOKIE_NAME, { path: '/' });
            console.log("cookie '" + COOKIE_NAME + "' deleted.");
          });

        });
        */

		
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('iframe[src*="youtube"]').parent().fitVids();

        // fix layout issues with uneven height images
        // $('.grid-item').matchHeight();
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        var mediaPlayer = document.getElementById('bg-video');
        var $mediaPlayer = $('#bg-video');
        
        // play/pause bg video
        function toggleMute() {
          
          // mediaPlayer.muted = !mediaPlayer.muted;
          // $('.mute-btn').toggle();
          // $('.unmute-btn').toggle();

          if (mediaPlayer.muted) { // unmute
            mediaPlayer.muted = false; 
            $('#bg-video').prop("muted", false);
            $('.unmute-btn').show();
            $('.mute-btn').hide();
          } else { // mute
            mediaPlayer.muted = true; 
            $('#bg-video').prop("muted", true);
            $('.mute-btn').show();
            $('.unmute-btn').hide();
          }

          
        }

        $(".video-controls").on("click", '.mute-unmute' ,function(){
          toggleMute();
          // var $mediaPlayer = $('#bg-video');
          
          // if ($(this).hasClass("muted")) {
          //   $('#bg-video').prop("muted", false);
          //   $(this).toggleClass('muted');
          //   $('.unmute-btn').show();
          //   $('.mute-btn').hide();
          // } else {
          //   $('#bg-video').prop("muted", true);
          //   $(this).toggleClass('muted');
          //   $('.mute-btn').show();
          //   $('.unmute-btn').hide();
          // }

          console.log('mute toggled');
        });

        // play/pause bg video
        function playPause() {
          // var mediaPlayer = document.getElementById('bg-video');
          if (mediaPlayer.paused || mediaPlayer.ended) {
            mediaPlayer.play(); 
            $('.pause-btn').show();
            $('.play-btn').hide();
          } else {
            mediaPlayer.pause(); 
            $('.play-btn').show();
            $('.pause-btn').hide();
          }
        }

        $(".play-pause").on("click", function(){
          playPause();
          console.log('play toggled');
        });

        /* remove for now as we don't have a video ***

    		var $vid = document.getElementById("bgvid");
    		// var pauseButton = document.querySelector("#polina button");

    		function vidFade() {
    			$vid.classList.add("stopfade");
    		}

    		$vid.addEventListener('ended', function(){
    			// only functional if "loop" is removed 
    			$vid.pause();
    			// to capture IE10
    			$vidFade();
    		});
        
        */

    		/**
    		* Video element
    		* @type {HTMLElement}
    		*/
    		// var video = document.getElementById("bgvid");

    		/**
    		* Check if video can play, and play it
    		*/
    		/*
        $vid.addEventListener( "canplay", function() {
    			$vid.play();
    			// console.log("Playing Video");
    		});
    		*/

    		/*
    	
    		// https://github.com/inorganik/countUp.js
    		var $cnt_options = {
    		  useEasing : true, 
    		  useGrouping : true, 
    		  separator : ',', 
    		  decimal : '.', 
    		  prefix : '', 
    		  suffix : '' 
    		};
    		var $count_1 = new CountUp("cntup_1", 0, 1242, 0, 1, $cnt_options);
    		var $count_2 = new CountUp("cntup_2", 0, 56, 0, 1, $cnt_options);
    		var $count_3 = new CountUp("cntup_3", 0, 71234, 0, 1, $cnt_options);				
    		
    		// https://github.com/imakewebthings/waypoints
    		var waypoint = new Waypoint({
    			element: document.getElementById('home-stats'),
    			handler: function() {
    				// notify('Basic waypoint triggered');
    				// console.log('waypoint triggered');
    				$count_1.start();
    				$count_2.start();
    				$count_3.start();
    			},
    			offset:'100%'
    		});
    		
    		*/
		
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
		
		// fade text over video 
		$(".big-banner-content").delay(5500).fadeOut( "slow", function() {
			console.log("Headline Fading out");
		});	
		
      }
    },
    // About us page, note the change from about-us to about_us.
    'locations': {
      init: function() {
        // JavaScript to be fired on the about us page
    			
    		$(".lm_map").click(function () {
    				$(this).find("iframe").css("pointer-events", "auto"); // only trigger pointer events for this map
    				console.log('clicked');
    		});
          }
    },
    // About us page, note the change from about-us to about_us.
    'single_trainers': {
      init: function() {
        // JavaScript to be fired on the about us page
		    // $(".tr-video").fitVids();
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        // $('iframe[src*="youtube"]').parent().fitVids();
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_locations': {
      init: function() {
        // JavaScript to be fired on the about us page
        $(".lm_map").click(function () {
          $(this).find("iframe").css("pointer-events", "auto"); // only trigger pointer events for this map
          console.log('clicked');
        });
      }
    },
    // About us page, note the change from about-us to about_us.
    'blog': {
      init: function() {
        // JavaScript to be fired on the about us page
		
		
		// Example AJAX call leveraging lib/ajax.php functions.
        // You could have this run on form submit, element click, etc.
        $(".load-more").click(function () {
			var ajaxExample = function() {
				// action: Matches add_action call in lib/ajax.php
				// nonce:  Matches our chosen nonce setup in lib/ajax.php
				var postVars = {
					action: 'roots_example_ajax', // roots_example_ajax
					nonce:  rootsAjax.exampleNonce,
			  };
			  // Perform our post.
			  $.post(rootsAjax.ajaxUrl, postVars)
				.done(function(response){
					// Log the response for testing.
					console.log(response);
				});
			}; // End ajaxExample
			console.log("load-more clicked");
		});
		
		// fix layout issues with uneven height containers
		$('.posts-row > div').matchHeight();
		
		
      }
    },
    // About us page, note the change from about-us to about_us.
    'archive': {
      init: function() {
        // JavaScript to be fired on the about us page
		
		// fix layout issues with uneven height containers
		$('.posts-row > div').matchHeight();
		
      }
    },
    // About us page, note the change from about-us to about_us.
    'past_events': {
      init: function() {
        
        $('.posts-row article header, .event-list header').matchHeight();

      }
    },
    // About us page, note the change from about-us to about_us.
    'post_type_archive_events': {
      init: function() {
        
        $('.posts-row article header, .event-list header').matchHeight();

      }
    },
    // About us page, note the change from about-us to about_us.
    'single_post': {
      init: function() {
        // JavaScript to be fired on the about us page
    $(".show-comments").click(function () {
      $( "#comments" ).slideToggle( "fast", function() {
        // Animation complete.
        console.log('Comments open');
      });
    });
      }
    },
    // About us page, note the change from about-us to about_us.
    'training_programs': {
      init: function() {
        // JavaScript to be fired on the about us page
		$('.training-item').matchHeight();
      }
    },
    // About us page, note the change from about-us to about_us.
    'get_started': {
      init: function() {
        // JavaScript to be fired on the about us page
	
        /*
        var feed = new Instafeed({
    			get: 'user',
    			userId: '219767652',
    			resolution: 'low_resolution', //  thumbnail, low_resolution, standard_resolution
    			limit: '5',
    			clientId: 'f66d45ce6123424d98140fcf3a0bfb62', // from instagram.com/developer/clients/
    			accessToken: '219767652.f66d45c.9ee15b16c6634a3bb94c1512bb38bf5e', // response from https://instagram.com/oauth/authorize/?client_id=f66d45ce6123424d98140fcf3a0bfb62&redirect_uri=http://www.austinsimplyfit.com&response_type=token
    			target: 'feed_grid', // ID of div to fill with images			
    			// template: '<div class="col-sm-15 col-xs-6 feed-item"><a href="{{link}}" target="_blank" class="ig-{{orientation}}"><img src="{{image}}" alt="" title="{{caption}}"></a></div>'
    			template: '<div class="col-sm-15 col-xs-6 feed-item"><a href="{{link}}" target="_blank" class="ig-{{orientation}} square" style="background-image:url({{image}});" title="{{caption}}"></a></div>'
    		});
    		
    		feed.run(); // start 'er up
        */
      },
    	  
      finalize: function() {
  		  // $('#feed_grid > div').matchHeight();
  	  }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
